import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import DateTimePicker from '@/views/Language/components/date-time/date-time.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'
import LanguageModel from '@/views/Language/models/language'
import TranslationJobModel from '@/views/Language/models/translationJob'

@Component({
    name: 'translation-job-input',
    components: { DialogTemplate, DateTimePicker },
})
export default class TranslationJobInput extends Mixins<MixinInterface>() {
    bottomSheet = true
    @Prop({ required: true }) props!: any

    get allLanguages() {
        return this.$store.getters.translationLanguages
    }

    get translationJob(): TranslationJobModel | null {
        return this.props.translationJob
    }

    get translationJobs(): Array<TranslationJobModel> {
        return this.props.translationJobs
    }

    get stringGroups(): Array<StringGroupModel> {
        return this.props.stringGroups
    }

    valid = true
    name = ''
    expiresAt = new Date()
    languages: Array<LanguageModel> = []
    groups: Array<StringGroupModel> = []

    selectMultipleRequired = [
        (v: any) =>
            (v && v.length > 0) ||
            this.getComplexTranslations(
                'language_fe.translationJob.dialog_input.validation.is_required'
            ),
    ]

    stringRules = [
        (v: any) =>
            (v && v.length > 1) ||
            this.getComplexTranslations(
                'language_fe.translationJob.dialog_input.validation.name.must_be_min_length'
            ),
        (v: any) =>
            this.testStringGroupName(v) ||
            this.getComplexTranslations(
                'language_fe.translationJob.dialog_input.validation.name.must_be_unique'
            ),
    ]

    testStringGroupName(input: string) {
        let res = true
        if (input.length > 1) {
            this.translationJobs.map((translationJobObject: TranslationJobModel) => {
                if (
                    this.translationJob &&
                    this.translationJob.name.toString().toLowerCase() ==
                        input.toString().toLowerCase()
                ) {
                    res = true
                } else if (
                    translationJobObject.name.toString().toLowerCase() ==
                    input.toString().toLowerCase()
                ) {
                    res = false
                }
            })
        }

        return res
    }

    loading = false

    mounted() {
        this.init()
    }

    init() {
        if (this.translationJob) {
            this.name = this.translationJob.name
            this.expiresAt = this.translationJob.expiresAt
            this.languages = this.translationJob.languages
            this.groups = this.translationJob.groups
        }
    }

    async patchTranslationJob() {
        if (this.valid && this.translationJob) {
            this.loading = true

            let data = {
                type: this.translationJob._type,
                id: this.translationJob._id,
                attributes: {
                    name: this.name,
                    expiresAt: this.expiresAt,
                },
                ...(this.languages.length > 0 &&
                    this.groups.length > 0 && {
                        relationships: {
                            languages: {
                                data: this.languages.map((tag) => {
                                    return { id: tag._id, type: tag._type }
                                }),
                            },
                            groups: {
                                data: this.groups.map((tag) => {
                                    return { id: tag._id, type: tag._type }
                                }),
                            },
                        },
                    }),
            }

            let translationJob = await this.translationJob.patch(data)

            this.loading = false
            this.$emit('close', translationJob)
        }
    }

    async postTranslationJob() {
        if (this.valid) {
            this.loading = true

            let data = {
                type: 'translationJob',
                attributes: {
                    name: this.name,
                    expiresAt: this.expiresAt,
                },
                ...(this.languages.length > 0 &&
                    this.groups.length > 0 && {
                        relationships: {
                            languages: {
                                data: this.languages.map((tag) => {
                                    return { id: tag._id, type: tag._type }
                                }),
                            },
                            groups: {
                                data: this.groups.map((tag) => {
                                    return { id: tag._id, type: tag._type }
                                }),
                            },
                        },
                    }),
            }

            let translationJob = await TranslationJobModel.post(data).catch(() => {
                //
            })

            this.loading = false

            this.$emit('close', translationJob)
        }
    }

    async submit() {
        if (this.valid) {
            if (this.translationJob) {
                await this.patchTranslationJob()
            } else {
                await this.postTranslationJob()
            }
        }
        this.$emit('close', true)
    }
}
